import { query, request } from '@/utils/request';

const urls = {
  basicInfo: '/api/zlbuser/institution/institution/basedetail', // 基础信息
  updateInfo: '/api/zlbuser/institution/base/info', // 编辑基础信息
};

export async function reqBasicInfo(params) {
  return request(urls.basicInfo, { params });
}

export async function updateBasicInfo(data) {
  return query(urls.updateInfo, { method: 'POST', data });
}
